import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export const setAuthToken = (token) => {
  if (token) {
    api.defaults.headers.common["Authorization"] = `Bearer ${token}`;
    localStorage.setItem("admin_token", token);
  } else {
    delete api.defaults.headers.common["Authorization"];
    localStorage.removeItem("admin_token");
  }
};

const stored = typeof window !== "undefined" ? localStorage.getItem("admin_token") : null;
if (stored) api.defaults.headers.common["Authorization"] = `Bearer ${stored}`;

export function formatApiError(detail) {
  if (detail == null) return "Si è verificato un errore. Riprova.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const WEEKDAYS_IT = ["Lunedì", "Martedì", "Mercoledì", "Giovedì", "Venerdì", "Sabato", "Domenica"];
export const MONTHS_IT = ["Gennaio","Febbraio","Marzo","Aprile","Maggio","Giugno","Luglio","Agosto","Settembre","Ottobre","Novembre","Dicembre"];

const IT_LOCALE = "it-IT";
const IT_TZ = "Europe/Rome";

/** Format a UTC/offset ISO string as Italian date "Venerdì 12 settembre 2026" */
export function fmtItalianDate(iso, { withYear = false } = {}) {
  const d = new Date(iso);
  const opts = { weekday: "long", day: "numeric", month: "long", timeZone: IT_TZ };
  if (withYear) opts.year = "numeric";
  const s = d.toLocaleDateString(IT_LOCALE, opts);
  return s.charAt(0).toUpperCase() + s.slice(1);
}

/** Format only HH:MM in Europe/Rome */
export function fmtItalianTime(iso) {
  const d = new Date(iso);
  return d.toLocaleTimeString(IT_LOCALE, { hour: "2-digit", minute: "2-digit", timeZone: IT_TZ });
}

/** Returns Europe/Rome date parts for a given iso: {y,m,d, weekday(0-6 Mon-Sun)} */
export function itParts(iso) {
  const d = new Date(iso);
  const parts = new Intl.DateTimeFormat("en-CA", { year: "numeric", month: "2-digit", day: "2-digit", weekday: "short", timeZone: IT_TZ })
    .formatToParts(d)
    .reduce((acc, p) => ({ ...acc, [p.type]: p.value }), {});
  const map = { Mon: 0, Tue: 1, Wed: 2, Thu: 3, Fri: 4, Sat: 5, Sun: 6 };
  return { y: parts.year, m: parts.month, day: parts.day, weekday: map[parts.weekday] };
}

export function buildWhatsAppUrl(number, message) {
  const n = (number || "").replace(/\D+/g, "");
  return `https://wa.me/${n}?text=${encodeURIComponent(message || "")}`;
}
